import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { badge, sliderImg1, sliderImg2, sliderImg3, sliderImg4, sliderImg5, sliderImg6, sliderImg7, sliderImg8 } from "../../../assets/img/index";
import { Link } from "react-router-dom";
import { FaEthereum } from "react-icons/fa";
import { SiBinance, SiPolymerproject } from "react-icons/si";

export default function Scroller(campaign) {
    const Ref = useRef(null);
    const [timer, setTimer] = useState('00:00:00');

    const settings = {
        dots: true,
        infinite: true,
        speed: 400,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        responsive: [
            {
                breakpoint: 1414,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1214,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1007,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 516,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const slider = [
        {
            img: sliderImg1,
            name: "@xander_hall...",
            price: "16.58 ETH",
            token: <FaEthereum className="m-2 badgeIcon" style={{ color: "gray" }} />
        },
        {
            img: sliderImg2,
            name: "@hamza_pitts...",
            price: "14.55 ETH",
            token: <SiPolymerproject className="m-2 badgeIcon" style={{ color: "purple" }} />
        },
        {
            img: sliderImg3,
            name: "@nathan_walls...",
            price: "24.13 ETH",
            token: <SiBinance className="m-2 badgeIcon" style={{ color: "yellow" }} />
        },
        {
            img: sliderImg4,
            name: "@kelton_colier...",
            price: "62.68 ETH",
            token: <FaEthereum className="m-2 badgeIcon" style={{ color: "gray" }} />
        },
        {
            img: sliderImg5,
            name: "@cade_glover...",
            price: "32.48 ETH",
            token: <SiPolymerproject className="m-2 badgeIcon" style={{ color: "purple" }} />
        },
        {
            img: sliderImg6,
            name: "@xander_hall...",
            price: "16.58 ETH",
            token: <SiBinance className="m-2" style={{ color: "yellow" }} />
        },
        {
            img: sliderImg7,
            name: "@hamza_pitts...",
            price: "14.55 ETH",
            token: <FaEthereum className="m-2 badgeIcon" style={{ color: "gray" }} />
        },
        {
            img: sliderImg8,
            name: "@nathan_walls...",
            price: "24.13 ETH",
            token: <SiBinance className="m-2 badgeIcon" style={{ color: "gray" }} />
        },
    ];

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);
        return {
            total, hours, minutes, seconds
        };
    };

    const startTimer = (e) => {
        let { total, hours, minutes, seconds } = getTimeRemaining(e);
        if (total >= 0) {
            setTimer(
                (hours > 9 ? hours : '0' + hours) + ':' +
                (minutes > 9 ? minutes : '0' + minutes) + ':' +
                (seconds > 9 ? seconds : '0' + seconds)
            );
        }
    };

    const clearTimer = (e) => {
        setTimer('00:00:10');
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000);
        Ref.current = id;
    };

    const getDeadTime = () => {
        let deadline = new Date();
        deadline.setSeconds(deadline.getSeconds() + 100000);
        return deadline;
    };

    useEffect(() => {
        clearTimer(getDeadTime());
    }, []);

    return (
        <div className="section_body swiper_artists overflow-hidden" style={{marginBottom:"8vh"}}>
            <Slider {...settings}>
                {slider.map((slider, index) => (
                    <div className="IDO" key={index}>
                        <div className="d-flex" style={{ flexDirection: "column", alignItems: "center" }}>
                            <div className="w-100 h-100" style={{ position: "relative" }}>
                                <Link to="#">
                                    <img
                                        src={slider.img}
                                        alt="Avatar"
                                        className="IDOImg d-flex align-item-center justify-content-center border-bottom"
                                        style={{ alignItems: "center", objectFit: "cover" }}
                                    />
                                </Link>
                                <div className="border rounded-circle launchpad1__scroller1_icon m-2">
                                    {slider.token}
                                </div>
                                <div className="d-flex ms-3 launchpad1__scroller1_subimgposition">
                                    <div>
                                        <img src={slider.img} className="launchpad1__scroller1_subimg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mx-4 IDO_block2">
                            <div className="IDOnae button-29" style={{ width: '50%', marginTop: "-3.6rem", position: "absolute", top: '-0.5rem', right: "-1.5rem" }}>
                                <h4 className='text-center my-1' style={{ alignItems: 'center', color: 'white' }}>
                                    Fire Xon
                                </h4>
                            </div>
                            <div className="mx-1 bggg d-flex align-items-center justify-content-between">
                                <div><span className="p4">Round Name</span></div>
                                <div><span className="p4">Public</span></div>
                            </div>
                            <div className="m-1 d-flex align-items-center justify-content-between">
                                <div><span className="p4">Participent</span></div>
                                <div><span className="p4">42</span></div>
                            </div>
                            <div className="m-1 d-flex align-items-center justify-content-between">
                                <div><span className="p4">Project Start</span></div>
                                <div><span className="p4">TBA</span></div>
                            </div>
                            <div className="m-1 d-flex align-items-center justify-content-between">
                                <div><span className="p4">Raised Amount</span></div>
                                <div><span className="p4">
                                    <span className="mx-1" style={{ color: "skyblue" }}>
                                        5000
                                    </span>
                                    /15000 BUSD
                                </span></div>
                            </div>
                            <div className="mt-2">
                                <Link to='/idodetails'>
                                    <button className="p4 border-0 btn btn-bg" style={{ backgroundColor: '#0039a6', color: 'white', marginBottom: '1vw' }}>
                                        View Details
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
}
